"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplyMessage = exports.QueryMessage = exports.EventMessage = exports.CommandMessage = void 0;
const zod_1 = require("zod");
const timestamp = zod_1.z.string().datetime();
const uuid = zod_1.z.string().uuid();
exports.CommandMessage = zod_1.z.object({
    type: zod_1.z.string(),
    version: zod_1.z.number().int().positive(),
    commandId: uuid,
    tenantId: zod_1.z.string(),
    /** TRACEONE: сквозной traceId звонка/захода (payload-носитель значения из header `x-trace-id`). */
    traceId: uuid.optional(),
    timestamp,
});
exports.EventMessage = zod_1.z.object({
    type: zod_1.z.string(),
    version: zod_1.z.number().int().positive(),
    eventId: uuid,
    tenantId: zod_1.z.string(),
    /** TRACEONE: сквозной traceId звонка/захода (payload-носитель значения из header `x-trace-id`). */
    traceId: uuid.optional(),
    timestamp,
});
exports.QueryMessage = zod_1.z.object({
    type: zod_1.z.string(),
    version: zod_1.z.number().int().positive(),
    queryId: uuid,
    tenantId: zod_1.z.string(),
    timestamp,
});
exports.ReplyMessage = zod_1.z.object({
    type: zod_1.z.string(),
    version: zod_1.z.number().int().positive(),
    /** Req/reply-корреляция (echo queryId запроса) — messaging-паттерн, НЕ доменный traceId (TRACEONE R3). */
    correlationId: uuid,
    tenantId: zod_1.z.string(),
    timestamp,
});
//# sourceMappingURL=message.js.map